var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"label":"","small":"","dark":"","color":_vm.organisation ? _vm.organisation.color : 'grey darken-2'}},[_vm._v(" "+_vm._s(_vm.organisation ? _vm.organisation.name : 'Both companies')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }